export enum ClaimTypeText {
  BD = 'It broke down',
  AD = 'It got damaged by accident',
}
